import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Tag = styled.div<{backgroundColor?: string; color?: string}>`
    display: inline-flex;
    margin: 3px;
    white-space: normal;
    vertical-align: top;
    padding: 5px 8px;
    border-radius: 4px;
    font-size: 12px;
    background-color: ${(p) => p.backgroundColor ?? (p.color ?? colors.textPrimary) + '33'};
    color: ${(p) => p.color ?? colors.textPrimary};
`;

export const Tags = styled.div`
    display: flex;
    flex-wrap: wrap;
`;
